import { createSlice } from '@reduxjs/toolkit';

const profilesSlice = createSlice({
  name: 'profiles',
  initialState: [],
  reducers: {
    addProfile(draft, action) {
      draft.push(action.payload);
    },

    removeProfile(draft, action) {
      const deletedProfileIndex = draft.findIndex((p) => p.profileId === action.payload);

      if (deletedProfileIndex !== -1) {
        draft.splice(deletedProfileIndex, 1);
      }
    },

    setProfiles(draft, action) {
      return action.payload;
    },

    updateProfile(draft, action) {
      const profileToUpdateIndex = draft.findIndex(
        (p) => p.profileId === action.payload?.profileId,
      );

      if (profileToUpdateIndex !== -1) {
        // NOTE: It's okay to reassign draft inside RTK's reducers
        // eslint-disable-next-line no-param-reassign
        draft[profileToUpdateIndex] = { ...draft[profileToUpdateIndex], ...action.payload };
      }
    },
  },
});

export const { addProfile, removeProfile, setProfiles, updateProfile } = profilesSlice.actions;

export default profilesSlice.reducer;

export const profilesSelector = (state) => state.profiles;
